import axios from 'axios';
import { axiosConfig, ThrowErrorMsg } from '../util';

import {
  ADD_STAFF,
  GET_STAFF,
  UPDATE_STAFF,
  DELETE_STAFF,
  UPDATE_CREDENTIAL,
  UPDATE_PERMISSION,
} from '../types';

const basePath = `${process.env.REACT_APP_API_URL}/v1`;

export const getStaffById = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${basePath}/staff/${id}`);

    dispatch({
      type:    GET_STAFF,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const getStaffs = () => async (dispatch) => {
  try {
    const res = await axios.get(`${basePath}/staffs`);

    dispatch({
      type:    GET_STAFF,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const addStaff = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`${basePath}/staff/add`, formData, axiosConfig);

    dispatch({
      type:    ADD_STAFF,
      payload: res.data,
    });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const updateStaff = (id, formData) => async (dispatch) => {
  try {
    const res = await axios.put(`${basePath}/staff/${id}`, formData, axiosConfig);

    dispatch({
      type:    UPDATE_STAFF,
      payload: res.data,
    });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const deleteStaff = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`${basePath}/staff/${id}`,  axiosConfig);

    dispatch({
      type:    DELETE_STAFF,
      payload: res.data,
    });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const updateCredential = (id, formData) => async (dispatch) => {
  try {
    const res = await axios.put(`${basePath}/staff/credential/${id}`, { formData }, axiosConfig);

    dispatch({
      type:    UPDATE_CREDENTIAL,
      payload: res.data,
    });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const updatePermission = (id, formData) => async (dispatch) => {
  try {
    const res = await axios.put(`${basePath}/staff/permission/${id}`, formData, axiosConfig);

    dispatch({
      type:    UPDATE_PERMISSION,
      payload: res.data,
    });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};
